import React, { useState } from "react";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://formspree.io/f/mqknelyk", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      });

      if (response.ok) {
        setSubmissionStatus("success");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setSubmissionStatus("error");
      }
    } catch (error) {
      setSubmissionStatus("error");
    }
  };

  return (
    <section className="bg-gray-900 text-white mb-0 py-16 min-h-screen" id="contact">
      <div className="mx-auto px-4 md:px-12">
        <h2 className="text-4xl font-bold mb-8 text-center" style={{ color: "rgb(92, 225, 230)" }}>Contact Me</h2>
        <div className="mb-8 mt-8 text-lg max-w-2xl mx-auto text-white text-center">
          <p>
            If you have an application you are interested in developing, a feature
            that you need built or a project that needs coding. I’d love to help with it
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <form className="mb-8" onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block mb-2" htmlFor="name">
                Name
              </label>
              <input
                className="appearance-none w-full py-2 px-4 bg-gray-800 text-white rounded leading-tight focus:outline-none focus:bg-white focus:text-gray-900"
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Abraha Kahsay"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2" htmlFor="email">
                Email
              </label>
              <input
                className="appearance-none w-full py-2 px-4 bg-gray-800 text-white rounded leading-tight focus:outline-none focus:bg-white focus:text-gray-900"
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="abrahak81@gmail.com"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block mb-2" htmlFor="message">
                Message
              </label>
              <textarea
                className="appearance-none w-full py-2 px-4 bg-gray-800 text-white rounded leading-tight focus:outline-none focus:bg-white focus:text-gray-900"
                id="message"
                rows="6"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Enter your message here"
                required
              ></textarea>
            </div>
            <div className="flex justify-center">
              <button
                className="bg-teal-600 hover:bg-teal-700 text-white font py-1 px-4 rounded focus:outline-none focus:shadow-outline"
                type="submit"
              >
                Get in Touch
              </button>
            </div>
          </form>

          {submissionStatus === "success" && (
            <div className="text-green-500 text-center mt-4">
              Message sent successfully!
            </div>
          )}
          {submissionStatus === "error" && (
            <div className="text-red-500 text-center mt-4">
              Failed to send message. Please try again later.
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;